import React from 'react';
import PageLoader from './PageLoader'

export default ({children, className, ready}) => {

  var cls = "page " + className;
  return (
  
  <div className={cls} id="content" >
    {ready ?
      children
      :
      <PageLoader />
    }
  </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/Page/Page.jsx